/**
 * Retrieves the session id used by flows to identify the session
 * @returns The session id included in the url
 */
const useBackRef = (): string | undefined => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);

  const back_ref = params.get('back_ref');
  if (back_ref && typeof back_ref === 'string') {
    return back_ref;
  }

  const backRef = params.get('backRef');
  if (backRef && typeof backRef === 'string') {
    return backRef;
  }

  return '';
};

export default useBackRef;
